var map = {
	"./b2c-site-fr-FR.po": 934
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 933;


//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/i18n nonrecursive \.po$
// module id = 933
// module chunks = 65